import { render, staticRenderFns } from "./PaymentChoosing.vue?vue&type=template&id=4c177d6e&scoped=true&"
import script from "./PaymentChoosing.vue?vue&type=script&lang=js&"
export * from "./PaymentChoosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c177d6e",
  null
  
)

export default component.exports